var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.09091 0H10.9091C11.5116 0 12 0.497461 12 1.11111V8.88889C12 9.50254 11.5116 10 10.9091 10H1.09091C0.488417 10 0 9.50254 0 8.88889V1.11111C0 0.497461 0.488417 0 1.09091 0ZM1.09082 3.67677V8.88894H10.909V3.67702L5.99992 6.17702L1.09082 3.67677ZM1.09082 2.43448L5.99994 4.93475L10.909 2.43476V1.11117H1.09082V2.43448Z",
    fill: "#607783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.28298c76cf34f0fbd38bda1712d85e63.svg";
export { ForwardRef as ReactComponent };